import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Location, Company } from '../interfaces/location.model';
import { AppService } from './app.service';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  errormessage:string=$localize`No data stored in session for 'companiesList'`;
  constructor(private http: HttpClient, private appService: AppService,) { }

  getLocations(): Observable<Location[]> {
    const companiesListString = sessionStorage.getItem('companiesList');

    if (companiesListString) {
      const companiesList: Company[] = JSON.parse(companiesListString);
      const allLocations: Location[] = companiesList.flatMap((company: Company) => {
        const locations = company.locations || company.Locations;

        return locations?.map((location: any) => ({
          id: location.id || location.Id,
          Name: location.description || location.Description,
          Address: location.address
            ? `${location.address.street || location.address.Street || ''}, ${location.address.postalCode || location.address.PostalCode || ''} ${location.address.city || location.address.City || ''}`.trim()
            : (location.Address || ''),
          code: location.code || location.Code,
          company: {
            id: company.id || (company as any).Id,
            name: company.name,
            description: company.description
          },
          fullAddress: location.address || location.Address,
          geoLatitude: location.address?.geoLatitude || location.address?.GeoLatitude,
          geoLongitude: location.address?.geoLongitude || location.address?.GeoLongitude,
          isSelected: location.isSelected || false
        })) || [];
      });

      return of(allLocations);
    }

    return of([]);
  }

}
